import { Alert as AntAlert } from 'antd';
import React from 'react';

export interface ErrorBoundaryProps {
  message?: React.ReactNode;
  description?: React.ReactNode;
}

/**
 * Divider component
 */
export const ErrorBoundary: React.FC<ErrorBoundaryProps> = (props) => (
  <AntAlert.ErrorBoundary {...props} />
);
